"use client";

export default function TrustedBrands() {
  const brands = ["Siemens", "Soraluce", "Heidenhain", "Fanuc"];
  const loop = [...brands, ...brands];
  return <section data-section-id="1996" id="trusted-brands" className="bg-background text-foreground border-t border-b border-steel-divider py-10 md:py-12 overflow-hidden">
      <div className="text-center mb-8">
        <span className="font-default text-xs md:text-sm uppercase tracking-widest text-muted-foreground">Brands We Trust</span>
      </div>

      <div className="relative">
        <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 md:w-32 bg-gradient-to-r from-background to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 md:w-32 bg-gradient-to-l from-background to-transparent" />

        <div className="group flex w-max">
          <div className="flex w-max items-center animate-[sole-marquee_28s_linear_infinite] group-hover:[animation-play-state:paused]">
            {loop.map((brand, i) => <div data-index={i} key={i} className="flex items-center justify-center px-8 md:px-14 shrink-0">
                <span className="font-default text-2xl md:text-4xl font-bold uppercase tracking-tighter text-foreground/20 transition-colors duration-0 hover:text-color-textPrimary">
                  {brand}
                </span>
              </div>)}
          </div>
        </div>
      </div>

      <style>{`
        @keyframes sole-marquee {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>;
}